import { apiClient } from "@/lib/api";
import type { FeedbackParams, PaginatedFeedback } from "@/types/feedback";

/**
 * Fetches a paginated list of recipient feedback (TASK-3814).
 * GET /api/v1/feedback/
 *
 * Empty-string filters are stripped so they are never sent as `?rating=` etc.,
 * and `has_comment` is only included when truthy (omitted means "all rows").
 */
export async function getFeedback(
  params: FeedbackParams,
): Promise<PaginatedFeedback> {
  const query: Record<string, string | number> = {};

  if (params.rating != null) query.rating = params.rating;
  if (params.date_from) query.date_from = params.date_from;
  if (params.date_to) query.date_to = params.date_to;
  if (params.driver_id != null) query.driver_id = params.driver_id;
  if (params.has_comment) query.has_comment = "true";
  if (params.search) query.search = params.search;
  if (params.page != null) query.page = params.page;

  const response = await apiClient.get<PaginatedFeedback>("/v1/feedback/", {
    params: query,
  });
  return response.data;
}
